<template>
    <div class="profile">
        <ul
            class="profile__menu"
            :style="justifyStyle"
        >
            <li
                v-for="tab in tabs"
                :key="tab.id"
                @click="setActiveTab(tab)"
            >
                <a
                    :style="fontSize"
                    :class="{ active: activeTab?.id === tab.id }"
                    href="javascript:void(0)"
                >{{ tab.name }}</a>
            </li>
        </ul>

        <KeepAlive class="tab-content">
            <component :is="activeTab.component" v-if="activeTab" :admin-type="adminType" :key="activeTab.id" />
        </KeepAlive>
    </div>
</template>

<script>
import AdminService from "../../services/AdminService";

export default {
    name: "TabContainer",
    props: {
        tabs: {
            type: Array,
            required: true
        },
        spaceBetween: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            activeTab: null,
            adminType: null

        };
    },
    computed: {
        fontSize() {
            return {
                fontSize : this.spaceBetween ? '12px' : '16px'
            }
        },
        justifyStyle() {
            return {
                justifyContent: this.spaceBetween ? 'space-between' : 'start',
            };
        },
    },
    methods: {
        async getAdminType() {
            try {
                const response = await AdminService.getAdminType()
                this.adminType = response.data
            } catch (error) {
                this.$showErrorMessage('Status was not updated')
                console.error(error)
            }
        },
        getActiveTab() {
            const urlParams = new URLSearchParams(window.location.search);
            const tabParam = urlParams.get('tab');

            if (tabParam) {
                const foundTab = this.tabs.find(tab => tab.name === tabParam);
                if (foundTab) {
                    this.activeTab = foundTab;
                    return;
                }
            }
            this.activeTab = this.tabs[0];
        },
        setActiveTab(tab) {
            this.activeTab = tab;
            window.history.pushState({ tab: tab.name }, "", `?tab=${tab.name}`);
        },
    },
    mounted() {
        this.getAdminType()
        this.getActiveTab();
    }
};
</script>


<style scoped>

</style>
